export default "__VITE_ASSET__bFoxnNVf__"